// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { maxWidth, minWidth, width } from '@mui/system';

const annotationStyles = {
  container: {
    position: 'relative',
  },
  panel: {
    position: 'absolute',
    top: '87%',
    right: '106%',
    background: 'white',
    padding: '12px',
    borderRadius: '6px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    zIndex: 9999,
    width: '170px',
  },
  triangle: {
    width: 0,
    height: 0,
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    borderBottom: '10px solid white',
    position: 'absolute',
    top: '-10px',
    right: '20px',
  },
  button: {
    padding: '8px 10px',
    background: 'white',
    color: '#021E40',
    border: '1px solid #ccc',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  iconMargin: {
    marginRight: '6px',
  },
};

export default annotationStyles;
